export default "__VITE_ASSET__203444e9__"